import './media.scss';

import { faImage } from '@fortawesome/free-regular-svg-icons';
import { faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Item, itemSelectors } from '@skinsoft/entity';
import { fetch } from '@skinsoft/network';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { empty } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Component, Watch } from 'vue-property-decorator';

@Component({
    props: ['item'],
    template: require('./media.html'),
})
export class Media extends ReactiveVue {
    public item: Item;

    public media: string = null as any;
    public mediaIcon = faImage;
    public loadingIcon = faCircleNotch;
    public errorIcon = faTimes;
    public error = false;
    public pending = false;

    public mounted() {
        this.fetchMedia();
    }

    private fetchMedia() {
        const mediaId = itemSelectors.media(this.item);

        if (!mediaId) {
            return;
        }

        this.pending = true;

        this.subscribeTo(
            fetch
                .api(`/downloadMedias?mediaId=${mediaId}&fileType=vignette250`, {
                    headers: {
                        Accept: '*/*',
                    },
                })
                .pipe(
                    catchError(error => {
                        // tslint:disable-next-line:no-console
                        console.error(error);
                        this.pending = false;
                        this.error = true;

                        return empty();
                    }),
                ),
            media => {
                this.media = media;
                this.pending = false;
            },
            'item',
        );
    }

    @Watch('item')
    private onItemChange(item) {
        this.unsubscribeFrom('item');
        this.fetchMedia();
    }
}
